export default {
  title: 'Aktywuj rezerwacje',
  buttons: {
    cancel: 'Anuluj',
    activate: 'Aktywuj rezerwacje',
  },
};
